import {getStore} from '@/services/store';
import {currentUser} from '@/services/FirestoreService';

const ConfigService = {
  userIsOnTeam: function (team: string) {
    const user = currentUser();
    if (team === 'acquisition') {
      return getStore().state.acquisitionTeamIds?.includes(user.uid);
    } else if (team === 'tax') {
      return getStore().state.taxTeamIds?.includes(user.uid);
    } else {
      console.error(`Unknown team: ${team}`);
      return false;
    }
  },
};

export {
  ConfigService,
};
